'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: 50%;\n  width: 6px;\n  height: 6px;\n  background: #2eae8f;\n  margin: 10px 10px 2px 10px;\n'], ['\n  border-radius: 50%;\n  width: 6px;\n  height: 6px;\n  background: #2eae8f;\n  margin: 10px 10px 2px 10px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  line-height: 25px;\n'], ['\n  line-height: 25px;\n']);

// hixme-ui


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = _styledComponents2.default.span(_templateObject);

var LineContainer = _styledComponents2.default.div(_templateObject2);

/* eslint-disable react/no-array-index-key */
var BulletList = function BulletList(_ref) {
  var bulletArray = _ref.bulletArray,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ['bulletArray']);
  return _react2.default.createElement(
    LineContainer,
    null,
    bulletArray.map(function (item, index) {
      return _react2.default.createElement(
        _container2.default,
        { flex: true, noPadding: true, id: 'bullet-item', key: 'bullet-list-' + index },
        _react2.default.createElement(
          _container2.default,
          { flex: true, noPadding: true },
          _react2.default.createElement(Circle, null)
        ),
        _react2.default.createElement(
          _text2.default,
          restProps,
          item
        )
      );
    })
  );
};

BulletList.propTypes = {
  bulletArray: _propTypes2.default.array.isRequired
};

exports.default = BulletList;
//# sourceMappingURL=BulletList.js.map


//////////////////
// WEBPACK FOOTER
// ../bullet-list/lib/BulletList.js
// module id = 675
// module chunks = 0